<template>
  <div class="view">
    <h1>{{$t('rates.title')}}</h1>
    <parallax height="500" :centered="true">
      <img src="../../public/background.jpg">
    </parallax>
    <div class="rates">
      <div v-html="$t('rates.description')"></div>
      <p>{{$t('rates.data')}}</p>
      <p>{{$t('rates.data_desc')}}</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Rates'
}
</script>

<style lang="scss" scoped>
.rates {
  text-align: left;
  .rooms, .meals {
    display: flex;
    flex-direction: column;
    h2 {
      text-align: left;
    }
    .room, .meal {
      display: flex;
      font-size: 18px;
    }
  }
  .rooms {
    background-color: white;
    padding: 20px 50px;
  }
  .meals {

    padding: 20px 0px;
    h2 {
      padding: 0px 50px;
    }
    .meal {
      padding: 0px 50px;
    }
  }
}
</style>